/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillCustomerRelationships} from '../api'

export const useMutationBackfillCustomerRelationships = createReactQueryMutationHook('backfillCustomerRelationships', backfillCustomerRelationships)
